import React from "react";
import { CardContent } from "@/components/ui/card";
import NotificationList from "../NotificationList";
import MobileNotificationList from "../mobile/MobileNotificationList";
import { SupabaseNotification } from "@/types/notifications";
import { useAllNotificationChatCounts } from "@/hooks/useAllNotificationChatCounts";

interface NotificationContentProps {
  isMobile: boolean;
  notifications: SupabaseNotification[];
  filteredNotifications: SupabaseNotification[];
  sortedNotifications: SupabaseNotification[];
  isLoading: boolean;
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  sortConfig?: { key: string; direction: 'asc' | 'desc' };
  requestSort?: (key: string) => void;
  formatDate: (date: string) => string;
  handleNotificationClick: (id: string) => void;
  handleArchive: (e: React.MouseEvent, id: string) => void;
  handleRestore: (e: React.MouseEvent, id: string) => void;
  handleDelete: (e: React.MouseEvent, id: string) => void;
  handleSendWebhook?: (e: React.MouseEvent, id: string) => void;
  viewMode: "active" | "archived";
  unreadCount: number;
}

const NotificationContent = ({
  isMobile,
  notifications,
  filteredNotifications,
  sortedNotifications,
  isLoading,
  searchTerm,
  setSearchTerm,
  sortConfig,
  requestSort,
  formatDate,
  handleNotificationClick,
  handleArchive,
  handleRestore,
  handleDelete,
  handleSendWebhook,
  viewMode,
  unreadCount
}: NotificationContentProps) => {
  const { getUnreadCount } = useAllNotificationChatCounts();

  return (
    <CardContent>
      {isMobile ? (
        <MobileNotificationList
          notifications={notifications}
          filteredNotifications={filteredNotifications}
          sortedNotifications={sortedNotifications}
          isLoading={isLoading}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          formatDate={formatDate}
          handleNotificationClick={handleNotificationClick}
          handleArchive={handleArchive}
          handleRestore={handleRestore}
          handleDelete={handleDelete}
          viewMode={viewMode}
          unreadCount={unreadCount}
          getUnreadChatCount={getUnreadCount}
        />
      ) : (
        <NotificationList
          notifications={notifications}
          filteredNotifications={filteredNotifications}
          sortedNotifications={sortedNotifications}
          isLoading={isLoading}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          sortConfig={sortConfig}
          requestSort={requestSort}
          formatDate={formatDate}
          handleNotificationClick={handleNotificationClick}
          handleArchive={handleArchive}
          handleRestore={handleRestore}
          handleDelete={handleDelete}
          handleSendWebhook={handleSendWebhook}
          viewMode={viewMode}
          unreadCount={unreadCount}
          getUnreadChatCount={getUnreadCount}
        />
      )}
    </CardContent>
  );
};

export default NotificationContent;
